const Constants = {
  ACCESS_PROPERTY: "access",
  REFRESH_PROPERTY: "refresh",
  USER_ID_PLACE_HOLDER: "<userId>",
  CHAT_ID_PLACE_HOLDER: "<chatId>",
  ENTER_KEY_CODE: 13,
};

export default Constants;
